import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import * as $ from 'jquery';
import { Observable, of } from 'rxjs';
import { Agencies_BranchesProperties } from '../Models/AgencyMasterProperties';
import { AirportProperties } from '../Models/AirportProperties';
import { BookingListGetSearchProperties, BookingSearchListProperties, BookingStatus, BookingTripDetailsSearch, managerlistbyuserid } from '../Models/BookingListProperties';
import { SupplierData, SuppliersListProperties } from '../Models/SuppliersProperties';
import { OfflineToOnlineProperties } from '../Models/TicketIssuanceProperties';
import { AirportService } from '../Services/airport.service';
import { BookingListService } from '../Services/bookingList.service';
import { SuppliersService } from '../Services/suppliers.service';
@Component({
    selector: 'app-booking-list-search-criteria',
    templateUrl: './booking-list-search-criteria.component.html',
    styleUrls: ['./booking-list-search-criteria.component.css']
})
/** BookingListSearchCriteria component*/
export class BookingListSearchCriteriaComponent {
  userId: number;
  offlinetoOnline = new OfflineToOnlineProperties();
  agencyCodeList$: Observable<Agencies_BranchesProperties[]>;
  agencyCodefinalList$: Observable<Agencies_BranchesProperties[]>;
  agencyList: Agencies_BranchesProperties[] = [];
  newagencyList: Agencies_BranchesProperties[] = [];
  bookingstatusList$: Observable<BookingStatus[]>;
  obj = new SuppliersListProperties();
  spdata: SupplierData[] = [];
  tripdetailobj = new BookingTripDetailsSearch();
  airportGetList:AirportProperties[]=[];
  bookingsearchobj = new BookingSearchListProperties();
  bookingsearchobjnewforTSuse = new BookingSearchListProperties();
  bookingList: BookingListGetSearchProperties[] = [];
  managerList: managerlistbyuserid[] = [];
  collapsed = false;
  /** BookingListSearchCriteria ctor */
  constructor(private airportService: AirportService,private supplierservice: SuppliersService,private bookingListService: BookingListService, private http: HttpClient, private router: Router, private TripModal: NgbModal) {

  }
  ngOnInit() {
    this.LoadAgencyList();
    this.LoadBookingStatusList();
    this.getSupplierList();
    this.getDataAirportAll();
 
  }
  LoadBookingStatusList() {
    this.bookingListService.GetAllBookingStatus().subscribe((data) => {
      this.bookingstatusList$ = of(data);
    });
  }
  getSupplierList() {
    this.supplierservice.getSuppliersList().subscribe((data: SuppliersListProperties) => {
      if (data) {
        this.obj = data;
        this.spdata = this.obj.airSupplier
      }
     // console.log(data);
    })
  }
  
  getDataAirportAll() {
    this.airportService.GetAllAirport().subscribe((data) => {


      this.airportGetList = data;

    });
  }
  agencyhead: boolean = false;

  LoadAgencyList() {
    try {
      let loginAgency = "";


      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
        loginAgency = localStorage.getItem("AgencyId")
        if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
          this.userId = Number(localStorage.getItem("UserId"));
        if (this.userId != 0) {
          this.bookingListService.GetAllAgencies(loginAgency, this.userId).subscribe((data) => {
            this.agencyList = data;
            this.agencyCodeList$ = of(data);
            this.bookingListService.getmanagerlistbyuserid(this.userId).subscribe((newdata) => {
              if (newdata.length > 0) {
                this.managerList = newdata;
                for (let i = 0; i < this.managerList.length; i++) {
                  if (this.managerList[i].agencyid == 'AG01') {
                    this.agencyhead = true;
                  }
                }
                if (this.agencyhead == true) {
                  this.agencyCodefinalList$ = this.agencyCodeList$;
                }
                else {
                  this.newagencyList = [];
                  for (let i = 0; i < this.managerList.length; i++) {
                    for (let j = 0; j < this.agencyList.length; j++) {
                      if (this.managerList[i].agencyid == this.agencyList[j].code) {
                        //let newagencyobj = new Agencies_BranchesProperties();
                        this.newagencyList.push(this.agencyList[j]);
                      }
                    }
                  }
                  this.agencyCodefinalList$ = of(this.newagencyList);
                  
                }
              }
              else {
                this.newagencyList = [];
                let agencyIds = new Agencies_BranchesProperties();
                agencyIds.code = localStorage.getItem("AgencyId");
                agencyIds.labelName = localStorage.getItem("AgencyId");
                this.newagencyList.push(agencyIds)
                this.agencyCodefinalList$ = of(this.newagencyList);
                //console.log('nothing',newdata);
              }
            })
          
          });
        }
      }
    }
    catch (e) {
    }
  }
  trippopup(triptarget) {
    this.TripModal.open(triptarget, {
      size: 'md',
    })
  }
  clickTripDetailsBtn() {
    if (this.tripdetailobj.fromAirport == "" || this.tripdetailobj.fromAirport == null || this.tripdetailobj.fromAirport == undefined) {
      document.getElementById("frommessageair").innerHTML = "Required Mobile";
      document.getElementById("clasairrborderfrom").classList.add("newRequired-BoxColor");
      document.getElementById("labelairfrom").style.color = "red";


      setTimeout(function () {

        document.getElementById("frommessageair").innerHTML = "";
        document.getElementById("clasairrborderfrom").classList.remove("newRequired-BoxColor");
        document.getElementById("labelairfrom").style.color = "";

      }

        , 5000);
    }
    if (this.tripdetailobj.toAirport == "" || this.tripdetailobj.toAirport == null || this.tripdetailobj.toAirport == undefined) {
      document.getElementById("tomessageair").innerHTML = "Required Mobile";
      document.getElementById("clasairrborderto").classList.add("newRequired-BoxColor");
      document.getElementById("labelairto").style.color = "red";


      setTimeout(function () {

        document.getElementById("tomessageair").innerHTML = "";
        document.getElementById("clasairrborderto").classList.remove("newRequired-BoxColor");
        document.getElementById("labelairto").style.color = "";

      }

        , 5000);
    }
    if (this.tripdetailobj.journeyType == "" || this.tripdetailobj.journeyType == null || this.tripdetailobj.journeyType == undefined) {
      document.getElementById("messageJourney").innerHTML = "Required Mobile";
      document.getElementById("clasJourneyborderto").classList.add("newRequired-BoxColor");
      document.getElementById("labelJourney").style.color = "red";


      setTimeout(function () {

        document.getElementById("messageJourney").innerHTML = "";
        document.getElementById("clasJourneyborderto").classList.remove("newRequired-BoxColor");
        document.getElementById("labelJourney").style.color = "";

      }

        , 5000);
    }
    if (this.tripdetailobj.fromAirport == "" || this.tripdetailobj.fromAirport == null || this.tripdetailobj.fromAirport == undefined
      || this.tripdetailobj.toAirport == "" || this.tripdetailobj.toAirport == null || this.tripdetailobj.toAirport == undefined ||
      this.tripdetailobj.journeyType == "" || this.tripdetailobj.journeyType == null || this.tripdetailobj.journeyType == undefined) {
      return;
    }
    this.bookingsearchobj.trip = `${this.tripdetailobj.fromAirport} to${this.tripdetailobj.toAirport} (${this.tripdetailobj.journeyType})`;
    this.TripModal.dismissAll();
  }

  SearchData() {
    
    this.bookingsearchobj.agencyId = localStorage.getItem("AgencyId");
    this.bookingsearchobj.userId = Number(localStorage.getItem("UserId"));
    this.bookingsearchobjnewforTSuse = JSON.parse(JSON.stringify(this.bookingsearchobj));
    if (this.bookingsearchobj.bookingID == null || this.bookingsearchobj.bookingID == undefined) {
      this.bookingsearchobj.bookingID = 0;
    }
    if (this.bookingsearchobj.fromBookingDate == null || this.bookingsearchobj.fromBookingDate == undefined) {
      this.bookingsearchobj.fromBookingDate = "";
    }
    if (this.bookingsearchobj.toBookingDate == null || this.bookingsearchobj.toBookingDate == undefined) {
      this.bookingsearchobj.toBookingDate = "";
    }
    if (this.bookingsearchobj.supplier == null || this.bookingsearchobj.supplier == undefined) {
      this.bookingsearchobj.supplier = "";
    }
    if (this.bookingsearchobj.pnr == null || this.bookingsearchobj.pnr == undefined ) {
      this.bookingsearchobj.pnr = "";
    }
    if (this.bookingsearchobj.travelDate == null || this.bookingsearchobj.travelDate == undefined) {
      this.bookingsearchobj.travelDate = "";
    }
    if (this.bookingsearchobj.tkt == null || this.bookingsearchobj.tkt == undefined) {
      this.bookingsearchobj.tkt = "";
    }
    if (this.bookingsearchobj.trip == null || this.bookingsearchobj.trip == undefined) {
      this.bookingsearchobj.trip = "";
    }
    if (this.bookingsearchobj.name == null || this.bookingsearchobj.name == undefined) {
      this.bookingsearchobj.name = "";
    }
    if (this.bookingsearchobj.byAgency == null || this.bookingsearchobj.byAgency == undefined) {
      this.bookingsearchobj.byAgency = "";
    }
    if (this.bookingsearchobj.bookingStatus == null || this.bookingsearchobj.bookingStatus == undefined) {
      this.bookingsearchobj.bookingStatus = 0;
    }
    this.bookingsearchobj.rowCount = 0;
    this.bookingListService.GetBookingSearch(this.bookingsearchobj).subscribe((data) => {
      this.bookingList = data;
      // console.log(this.bookingList)
     /* this.bookingsearchobj = new BookingSearchListProperties();*/
      document.querySelector(".LoadButton").classList.remove("activeLoading");
    })
  }
  nextSearchData() {

    this.bookingsearchobjnewforTSuse.rowCount = this.bookingList.length;
    if (this.bookingsearchobjnewforTSuse.bookingID == null || this.bookingsearchobjnewforTSuse.bookingID == undefined) {
      this.bookingsearchobjnewforTSuse.bookingID = 0;
    }
    if (this.bookingsearchobjnewforTSuse.fromBookingDate == null || this.bookingsearchobjnewforTSuse.fromBookingDate == undefined) {
      this.bookingsearchobjnewforTSuse.fromBookingDate = "";
    }
    if (this.bookingsearchobjnewforTSuse.toBookingDate == null || this.bookingsearchobjnewforTSuse.toBookingDate == undefined) {
      this.bookingsearchobjnewforTSuse.toBookingDate = "";
    }
    if (this.bookingsearchobjnewforTSuse.supplier == null || this.bookingsearchobjnewforTSuse.supplier == undefined) {
      this.bookingsearchobjnewforTSuse.supplier = "";
    }
    if (this.bookingsearchobjnewforTSuse.pnr == null || this.bookingsearchobjnewforTSuse.pnr == undefined) {
      this.bookingsearchobjnewforTSuse.pnr = "";
    }
    if (this.bookingsearchobjnewforTSuse.travelDate == null || this.bookingsearchobjnewforTSuse.travelDate == undefined) {
      this.bookingsearchobjnewforTSuse.travelDate = "";
    }
    if (this.bookingsearchobjnewforTSuse.tkt == null || this.bookingsearchobjnewforTSuse.tkt == undefined) {
      this.bookingsearchobjnewforTSuse.tkt = "";
    }
    if (this.bookingsearchobjnewforTSuse.trip == null || this.bookingsearchobjnewforTSuse.trip == undefined) {
      this.bookingsearchobjnewforTSuse.trip = "";
    }
    if (this.bookingsearchobjnewforTSuse.name == null || this.bookingsearchobjnewforTSuse.name == undefined) {
      this.bookingsearchobjnewforTSuse.name = "";
    }
    if (this.bookingsearchobjnewforTSuse.byAgency == null || this.bookingsearchobjnewforTSuse.byAgency == undefined) {
      this.bookingsearchobjnewforTSuse.byAgency = "";
    }
    if (this.bookingsearchobjnewforTSuse.bookingStatus == null || this.bookingsearchobjnewforTSuse.bookingStatus == undefined) {
      this.bookingsearchobjnewforTSuse.bookingStatus = 0;
    }
    this.bookingListService.GetBookingSearch(this.bookingsearchobjnewforTSuse).subscribe((data) => {
      document.querySelector(".NextButton").classList.remove("activeLoadings");
      if (data.length > 0) {


        let listnew: BookingListGetSearchProperties[] = [];
        listnew = data;
        /*  this.bookingList = [...listnew]*/
        /*      this.bookingList= this.bookingList.map(s => { return { ...s, data } });*/
        for (let i = 0; i < listnew.length; i++) {
          let objs = new BookingListGetSearchProperties();
          objs.agencyId = listnew[i].agencyId;
          objs.bookingDate = listnew[i].bookingDate;
          objs.bookingID = listnew[i].bookingID;
          objs.bookingStatus = listnew[i].bookingStatus;
          objs.name = listnew[i].name;
          objs.pnr = listnew[i].pnr;
          objs.requestTypeName = listnew[i].requestTypeName;
          objs.supplier = listnew[i].supplier;
          objs.tkt = listnew[i].tkt;
          objs.travelDate = listnew[i].travelDate;
          objs.trip = listnew[i].trip;
          this.bookingList.push(objs);
        }
        //console.log(this.bookingList);

      }
      else {
        document.getElementById("Message_next").innerHTML = "No More Data";
        document.getElementById("errortext").classList.remove("hidemarginss");
        setTimeout(function () {

         
          document.getElementById("Message_next").innerHTML = "";
          document.getElementById("errortext").classList.add("hidemarginss");

        }

          , 5000);
      }
    })
  }
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "#f9f9f9", "color": "#212529", "font-weight": "bold" });
    $(".dx-checkbox-icon").css({ "border":"1px solid black" });
    $(".dx-button-content").css({ "background-color":"var(--first-color-second)" });
    $(".dx-icon.dx-icon-export-to").css({ "color":"white" });
    $(".dx-datagrid-header-panel").css({ "background-color": "#f9f9f9" });
    $(".dx-toolbar-items-container").css({ "background-color": "#f9f9f9" });
    $(".dx-row.dx-data-row.dx-row-lines.dx-column-lines").css({ "border": "none", "background-color": "#f9f9f9" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
  onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      autoFilterEnabled: true,
      customizeCell: function (options) {
        const excelCell = options;
        // exce = { name: 'Arial', size: 12 };
        // excelCell.alignment = { horizontal: 'left' };
      }
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'BookingSearchReport.xlsx');
        });
    });
    e.cancel = true;
  }
  infoText(currentPageNumber, totalPageCount, totalRowCount) {
    let pagenum = currentPageNumber;
    
    //let number = this.dataGrid.instance.pageCount();
    if (pagenum == totalPageCount) {
      //console.log('totalPageCount', totalPageCount);
      //console.log('pagenum', pagenum);
      if (totalRowCount > 1 ) {
        document.getElementById('buttonnext').classList.remove('hiddenclass');
      }
    }
    else {
      try {
        document.getElementById('buttonnext').classList.add('hiddenclass');
      }
      catch (ex) { console.log(ex); }

    }

  }
  NextButtonClick() {
    document.querySelector(".NextButton").classList.add("activeLoadings");
    this.nextSearchData();
  }
  LoadButtonClick() {
    document.querySelector(".LoadButton").classList.add("activeLoading");
    this.SearchData();
  } 
  Edit_Click(getdata) {
    try {
      if (getdata.bookingStatus == "Requested") {
        this.bookingListService.getBookingrequestId(getdata.bookingID).subscribe((data) => {
          if (data.requestTypeName == "Online Ticket Request") {
            localStorage.setItem("bookingID", getdata.bookingID);
            this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
            this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
            this.offlinetoOnline.TicketIssueReqFromOffline = true;
            localStorage.setItem("fromroutePageNoright", "BookingPageSearch"); 
            this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
            localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
            this.router.navigateByUrl('/ticket-issuance');
          }
          else if (data.requestTypeName == "Online Void Request") {
            localStorage.setItem("bookingID", getdata.bookingID);
            this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
            this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
            this.offlinetoOnline.VoidReqFromOffline = true;
            localStorage.setItem("fromroutePageNoright", "BookingPageSearch");
            this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
            localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
            this.router.navigateByUrl('/ticket-issuance');
          }
          else if (data.requestTypeName == "Online PNR Cancel Request") {
            localStorage.setItem("bookingID", getdata.bookingID);
            this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
            this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
            this.offlinetoOnline.PNRReqFromOffline = true;
            localStorage.setItem("fromroutePageNoright", "BookingPageSearch");
            this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
            localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
            this.router.navigateByUrl('/ticket-issuance');
          }
          else if (data.requestTypeName == "Online Refund Request") {
            localStorage.setItem("bookingID", getdata.bookingID);
            this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
            this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
            this.offlinetoOnline.RefundReqFromOffline = true;
            localStorage.setItem("fromroutePageNoright", "BookingPageSearch");
            this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
            localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
            this.router.navigateByUrl('/ticket-issuance');
          }
        })

      }
      else {
        localStorage.setItem('bookingID', getdata.bookingID);
        localStorage.setItem("fromroutePageNoright", "BookingPageSearch");
        this.router.navigateByUrl('/ticket-issuance');
      }

    }
    catch (e) { }
  }
}
